import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";

interface Props {
  size?: "medium" | "small";
}

export const Quantifiction = (props: Props) => {
  const { size } = props;

  return (
    <Link component={RouterLink} to="/home" underline="none">
      <Typography variant="h6" color="primary" style={{ fontWeight: 900 }}>
        Quantifiction
      </Typography>
      {size !== "small" && (
        <Typography
          variant="subtitle1"
          color="textSecondary"
          style={{ lineHeight: 1 }}
        >
          Sell better stories with science
        </Typography>
      )}
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageWrapper/Quantifiction.tsx